import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getAccountIntegrations } from "../../../redux/actions/onbordingActions";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import Loading from "../../../shared/loading/loading";
import IntegrationCard from "../integrationCard/integrationCard";

import { iacProviders, integrationIcons, buckets } from "../../../utils/icons";
import "./iacStep.scss";

const IacStep = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const integrations = useSelector(
    (state) => state.onbordingReducer.integrations
  );

  useEffect(() => {
    handleFetchProviders();
  }, []);

  const handleFetchProviders = async () => {
    await dispatch(getAccountIntegrations());
    setLoading(false);
  };

  const terraform = [
    {
      icon: buckets["aws_bucket"],
      title: "S3 Bucket",
      coming_soon: false,
      connected: false,
      auto: true,
    },
    {
      icon: integrationIcons["gcs"],
      title: "GCP GCS",
      onClick: () => history.push("/integrations/gcs-integration"),
      coming_soon: false,
      connected: !isEmpty(integrations?.gcs),
    },
    {
      icon: integrationIcons["consul"],
      title: "HashiCorp Consul",
      onClick: () => history.push("/integrations/consul-integration"),
      coming_soon: false,
      connected: !isEmpty(integrations?.consul),
    },
    {
      icon: iacProviders("terraform"),
      title: "Terraform Cloud",
      onClick: () => history.push({
        pathname: "/integrations/tfc-integration",
        state: { onboarding: true }
      }),
      coming_soon: false,
      connected: !isEmpty(integrations?.terraform),
    },
  ];

  const other = [
    {
      icon: iacProviders("cloudFormation"),
      title: "CloudFormation",
      coming_soon: false,
      connected: false,
      auto: true,
    },
    {
      icon: iacProviders("pulumi"),
      title: "Pulumi Cloud",
      onClick: () => history.push("/integrations/pulumi-integration"),
      coming_soon: true,
      connected: !isEmpty(integrations?.pulumi),
    }
  ];

  const renderInteg = (arr) => {
    return map(arr, (item) => {
      return (
        <IntegrationCard
          key={item?.title}
          icon={item?.icon}
          title={item?.title}
          onClick={item?.onClick}
          coming_soon={item?.coming_soon}
          connected={item?.connected}
          auto={item?.auto}
        />
      );
    });
  };
  return (
    <div className="IacStep col">
      {loading ? (
        <div className="tab-page center">
          <Loading />
        </div>
      ) : (
        <div className="IacStep__integs col">
          <span className="IacStep__integs-sub">Terrafom Backend</span>
          <div className="IacStep__integs-list">{renderInteg(terraform)}</div>
          <span className="IacStep__integs-sub">Additional IaC tools</span>
          <div className="IacStep__integs-list">{renderInteg(other)}</div>
        </div>
      )}{" "}
    </div>
  );
};

export default IacStep;
